import type { TimelineEvent } from '../data/timelineData';

export interface TrattoDecennio {
  inizio: number;
  etichetta: string;
  eventi: TimelineEvent[];
}

export const inizioDecennio = (anno: string | number): number => Math.floor(Number(anno) / 10) * 10;

export const etichettaDecennio = (inizio: number): string =>
  inizio < 2000 ? `Anni '${String(inizio).slice(2)}` : `Anni ${inizio}`;

// Raggruppa le tappe per decennio mantenendo l'ordine dei dati
export const raggruppaPerDecennio = (eventi: TimelineEvent[]): TrattoDecennio[] => {
  const tratti: TrattoDecennio[] = [];
  for (const evento of eventi) {
    const inizio = inizioDecennio(evento.year);
    const ultimo = tratti[tratti.length - 1];
    if (ultimo && ultimo.inizio === inizio) {
      ultimo.eventi.push(evento);
    } else {
      tratti.push({ inizio, etichetta: etichettaDecennio(inizio), eventi: [evento] });
    }
  }
  return tratti;
};

// Anno da mostrare sul contachilometri: quello dell'ultima tappa superata dal punto di lettura
export const annoRaggiunto = (posizioniTappe: { anno: string; y: number }[], yLettura: number): string | null => {
  let anno: string | null = null;
  for (const tappa of posizioniTappe) {
    if (tappa.y <= yLettura) anno = tappa.anno;
    else break;
  }
  return anno;
};
